import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { PageContentService } from 'src/services/pagecontent.service';

@Component({
    selector: 'app-user-menu',
    templateUrl: './user-menu.component.html',
    styleUrls: ['./user-menu.component.scss']
})
export class UserMenuComponent implements OnInit {
    isSitemapcheck: boolean;

    isShowLogin: boolean;
    isShowLogincheck: boolean;
    siteConfigList: [];
    loginlist: [];

    constructor(public appService: AppService, public pageservice: PageContentService) { }

    ngOnInit() {
        this.siteConfigList = [];
        this.getSiteConfig();
    }
    getSiteConfig() {
        this.pageservice.getSiteconfig().subscribe(result => {
            if (result != null) {
                
                this.siteConfigList = result;
                this.isSitemapcheck = result.isSiteMap;
                this.isShowLogin = result.isShowLogin;
                this.loginlist = result.loginSiteConfig;
                // this.isShowLogincheck = result.isShowLogin;
            }
        });
    }

}
